
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rivenditori/contatta/[slug]",
      function () {
        return require("private-next-pages/rivenditori/contatta/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rivenditori/contatta/[slug]"])
      });
    }
  